import type { ReactNode } from 'react';
import { Logo } from '@/components/ui';

export function AuthLayout({
  title,
  sub,
  children,
}: {
  title: string;
  sub?: string;
  children: ReactNode;
}) {
  return (
    <div className="screen">
      <div className="topbar">
        <Logo />
      </div>
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0 24px 60px',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: 420,
            display: 'flex',
            flexDirection: 'column',
            gap: 20,
            animation: 'rise .5s both',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <h1
              style={{ fontSize: 32, fontWeight: 800, letterSpacing: '-.035em', lineHeight: 1.05 }}
            >
              {title}
            </h1>
            {sub && <p style={{ fontSize: 14.5, color: '#666', lineHeight: 1.5 }}>{sub}</p>}
          </div>
          <div className="auth-card">{children}</div>
        </div>
      </div>
    </div>
  );
}
